import Tag from './src/main'

Tag.install = function (Vue) {
    Vue.components(Tag.name, Tag)
}

export default Tag